module.exports = __webpack_public_path__ + "static/media/1.4ec1d83b.png";